<template>
  <div>123</div>
</template>

<script>
export default {
  name: 'Promotion',
  data () {
    return {

    }
  }
}
</script>

<style>

</style>
